<template>
  <div class="hzc-discuss">
    <div class="mask" @click="closeIndustrial"></div>
    <div class="content">
      <p class="banner-title">{{ chainTitle }}</p>
      <div class="data1">{{ data1['druidParamName'] }}<em v-if="data1['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data1['price'] }}</span></div>
      <div class="data2">{{ `${data2['druidParamName']}` }}<em v-if="data2['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data2['price'] }}</span>
      </div>
      <div class="data3">{{ `${data3['druidParamName']}` }}<em v-if="data3['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data3['price'] }}</span>
      </div>
      <div class="data4">{{ `${data4['druidParamName']}` }}<em v-if="data4['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data4['price'] }}</span>
      </div>
      <div class="data5">{{ `${data5['druidParamName']}` }}<em v-if="data5['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data5['price'] }}</span>
      </div>
      <div class="data6">{{ `${data6['druidParamName']}` }}<em v-if="data6['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data6['price'] }}</span>
      </div>
      <div class="data7">{{ `${data7['druidParamName']}` }}<em v-if="data7['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data7['price'] }}</span>
      </div>
      <div class="data8">{{ `${data8['druidParamName']}` }}<em v-if="data8['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data8['price'] }}</span>
      </div>
      <div class="differPrice1 redColor" v-if="chainPrice['differPrice1'] > 0">
        {{ '+' + chainPrice['differPrice1'] }}
      </div>
      <div class="differPrice1 greenColor" v-if="chainPrice['differPrice1'] < 0">{{ chainPrice['differPrice1'] }}
      </div>
      <div class="differPrice1" v-if="chainPrice['differPrice1'] === 0">—</div>
      <div class="differPrice2 redColor" v-if="chainPrice['differPrice2'] > 0">
        {{ '+' + chainPrice['differPrice2'] }}
      </div>
      <div class="differPrice2 greenColor" v-if="chainPrice['differPrice2'] < 0">{{ chainPrice['differPrice2'] }}
      </div>
      <div class="differPrice2" v-if="chainPrice['differPrice2'] === 0">—</div>
      <div class="differPrice3 redColor" v-if="chainPrice['differPrice3'] > 0">
        {{ '+' + chainPrice['differPrice3'] }}
      </div>
      <div class="differPrice3 greenColor" v-if="chainPrice['differPrice3'] < 0">{{ chainPrice['differPrice3'] }}
      </div>
      <div class="differPrice3" v-if="chainPrice['differPrice3'] === 0">—</div>
      <div class="differPrice4 redColor" v-if="chainPrice['differPrice4'] > 0">
        {{ '+' + chainPrice['differPrice4'] }}
      </div>
      <div class="differPrice4 greenColor" v-if="chainPrice['differPrice4'] < 0">{{ chainPrice['differPrice4'] }}
      </div>
      <div class="differPrice4" v-if="chainPrice['differPrice4'] === 0">—</div>
      <div class="differPrice5 redColor" v-if="chainPrice['differPrice5'] > 0">
        {{ '+' + chainPrice['differPrice5'] }}
      </div>
      <div class="differPrice5 greenColor" v-if="chainPrice['differPrice5'] < 0">{{ chainPrice['differPrice5'] }}
      </div>
      <div class="differPrice5" v-if="chainPrice['differPrice5'] === 0">—</div>
      <div class="differPrice6 redColor" v-if="chainPrice['differPrice6'] > 0">
        {{ '+' + chainPrice['differPrice6'] }}
      </div>
      <div class="differPrice6 greenColor" v-if="chainPrice['differPrice6'] < 0">{{ chainPrice['differPrice6'] }}
      </div>
      <div class="differPrice6" v-if="chainPrice['differPrice6'] === 0">—</div>
    </div>
  </div>
</template>

<script>

export default {
  props: [
    'chainTitle',
    'data1',
    'data2',
    'data3',
    'data4',
    'data5',
    'data6',
    'data7',
    'data8',
    'chainPrice'
  ],
  data() {
    return {}
  },
  created() {
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'overflow:hidden')
  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style')
  },
  methods: {
    /**
     * 关闭
     */
    closeIndustrial(val) {
      this.$emit('closeIndustrialCh', val);
    },
  }
}
</script>

<style lang="less" scoped>
.hzc-discuss {
  z-index: 101;
  width: 980px;
  height: 544px;
  background-color: #fff;

  .confirm {
    position: fixed;
    right: 10px;
    top: 10px;
    z-index: 110;
    width: 50px;
    cursor: pointer;
  }

  .mask {
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  .content {
    width: 980px;
    height: 546px;
    display: inline-block;
    background: url("../../assets/steel/banner.png");
    background-size: 100% 100%;
    color: #fff;
    z-index: 101;
    position: relative;

    img {
      width: 980px;
      height: 544px;
    }

    .banner-title {
      position: absolute;
      font-size: 18px;
      top: 45px;
      left: 406px;
    }

    .data1 {
      font-size: 16px;
      position: absolute;
      top: 205px;
      left: 40px;
      width: 170px;
      height: 70px;
    }

    .data2 {
      font-size: 16px;
      position: absolute;
      top: 205px;
      left: 269px;
      width: 170px;
      height: 70px;
    }

    .data3 {
      font-size: 16px;
      position: absolute;
      top: 390px;
      left: 269px;
      width: 170px;
      height: 70px;
    }

    .data4 {
      font-size: 16px;
      position: absolute;
      top: 205px;
      left: 511px;
      width: 170px;
      height: 70px;
    }

    .data5 {
      font-size: 16px;
      position: absolute;
      top: 57px;
      right: 32px;
      width: 170px;
      height: 70px;
    }

    .data6 {
      font-size: 16px;
      position: absolute;
      top: 195px;
      right: 32px;
      width: 170px;
      height: 70px;
    }

    .data7 {
      font-size: 16px;
      position: absolute;
      top: 330px;
      right: 32px;
      width: 170px;
      height: 70px;
    }

    .data8 {
      font-size: 16px;
      position: absolute;
      top: 466px;
      right: 32px;
      width: 170px;
      height: 70px;
    }

    .differPrice1 {
      position: absolute;
      top: 209px;
      left: 456px;
      height: 25px;
      text-align: center;
    }

    .differPrice2 {
      position: absolute;
      top: 389px;
      left: 459px;
      height: 25px;
      text-align: center;
    }

    .differPrice3 {
      position: absolute;
      top: 66px;
      right: 233px;
      height: 25px;
      text-align: center;
    }

    .differPrice4 {
      position: absolute;
      top: 207px;
      right: 233px;
      height: 25px;
      text-align: center;
    }

    .differPrice5 {
      position: absolute;
      top: 327px;
      right: 233px;
      height: 25px;
      text-align: center;
    }

    .differPrice6 {
      position: absolute;
      top: 454px;
      right: 228px;
      height: 25px;
      text-align: center;
    }
  }

  .redColor {
    color: #FF6969;
  }

  .greenColor {
    color: #43E97B;
  }
}
</style>
